import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Gestisce il widget del piano capitoli: drag, rename, add, remove.
// Lo stato vive nel DOM fino alla conferma; serialize() lo impacchetta
// nel campo hidden prima del submit.
export default class extends Controller {
  static targets = ["list", "payload"]
  static values = { placeholder: String }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: ".drag-handle",
      animation: 150
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  removeRow(event) {
    event.target.closest(".plan-row").remove()
  }

  addRow() {
    const row = document.createElement("div")
    row.className = "plan-row flex items-center gap-2 bg-surface rounded-lg px-2 py-1.5 border border-border"
    row.dataset.key = "custom"
    row.dataset.instructions = ""
    row.dataset.rationale = ""
    row.innerHTML = `
      <span class="drag-handle cursor-grab active:cursor-grabbing text-text-secondary/40">⠿</span>
      <input type="text" class="flex-1 bg-transparent text-sm outline-none"
             data-section-plan-target="title" placeholder="${this.placeholderValue || "Titolo del capitolo…"}">
      <button type="button" class="text-text-secondary/40 hover:text-error shrink-0" data-action="section-plan#removeRow">✕</button>
    `
    this.listTarget.appendChild(row)
    row.querySelector("input").focus()
  }

  serialize() {
    const rows = Array.from(this.listTarget.querySelectorAll(".plan-row"))
    const sections = rows
      .map((row, index) => ({
        key: row.dataset.key,
        title: (row.querySelector("input")?.value || row.textContent).trim(),
        instructions: row.dataset.instructions || "",
        rationale: row.dataset.rationale || "",
        position: index
      }))
      .filter((section) => section.title.length > 0)
    this.payloadTarget.value = JSON.stringify(sections)
  }
}
